export default "__VITE_ASSET__ti3wCQHM__"